module.exports = __webpack_public_path__ + "img/confianza.1e4b09c8.svg";